import React, { createContext } from 'react';
import { ILogin, IUnlockScreen, IUser } from './Auth';
import { initialState } from 'redux/modules/session/reducer';

const authContext = createContext({
	...initialState(),
	initiateLogin: (user: IUser): React.ReactElement | null => null,
	handleAuthentication: (user: ILogin): void => {},
	handleScreenUnlock: (user: IUnlockScreen): void => {},
	handleValidateLoginWithOTP: (user: string, OTP: string): void => {},
	logout: () => {},
	OTPModalOpen: false,
	isWrongOTP: false,
	isValidatingOTP: false,
	checkingToken: false,
});

export const AuthProvider = authContext.Provider;
export const AuthConsumer = authContext.Consumer;
export default authContext;
